// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__1VAyJ","white":"Button_white__3kMAX","s-size":"Button_s-size__1NszI","upper":"Button_upper__FKpt1","wide":"Button_wide__1QOe4"};